import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pie",
  "use": "icon-pie-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pie\"><path d=\"M469.333333 213.333333v85.333334c-119.466667 12.8-213.333333 110.933333-213.333333 234.666666 0 128 106.666667 234.666667 234.666667 234.666667 123.733333 0 221.866667-93.866667 234.666666-213.333333h85.333334c-12.8 166.4-149.333333 298.666667-320 298.666666C315.733333 853.333333 170.666667 708.266667 170.666667 533.333333c0-170.666667 132.266667-307.2 298.666666-320z m384 298.666667h-341.333333V170.666667c187.733333 0 341.333333 153.6 341.333333 341.333333z m-256-243.2V426.666667h157.866667c-12.8-42.666667-106.666667-145.066667-157.866667-157.866667z\" p-id=\"1682\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pie.svg
// module id = +hJ1
// module chunks = 68